<div class="iframe-container">
  <!-- Ne pas renommer les iframes, ils sont utilisés dans d'autres composants avec leurs noms exacts, 
    sinon il faudra mettre à jour tous les composants qui les utilisent -->
  <iframe *ngIf="_data && !isCourrierOrOrdonnance"
    name="quill-iframe"
    [id]="_data.id"
    [title]="_data.title"
    [width]="!_data.isPagedJSActive ? iframeDimensions.width : ''"
    [height]="iframeDimensions.height"
    [srcdoc]="_data.data"
    [class.a4]="_data.isPagedJSActive"
    (load)="onIframeLoaded($event)">
  </iframe>

  <iframe *ngIf="_data"
    id="quill-iframe-hidden"
    name="quill-iframe-hidden"
    [srcdoc]="_data.dataPrint">
  </iframe>

  <iframe *ngIf="_data && isCourrierOrOrdonnance"
    name="quill-iframe-courrier"
    [id]="_data.id"
    [title]="_data.title"
    [width]="!_data.isPagedJSActive ? iframeDimensions.width : ''"
    [height]="iframeDimensions.height"
    [srcdoc]="_data.dataPrint"
    [class.a4]="true"
    (load)="onIframeLoaded($event)">
  </iframe>
</div>
